import {
    AnimationBuilder,
    RouteAction,
    RouterDirection,
    RouterOptions,
    UseIonRouterResult,
    useIonRouter,
} from '@ionic/react';

export const useCustomRouter = (): UseIonRouterResult => {
    const router = useIonRouter();
    const push = (
        pathname: string,
        routerDirection?: RouterDirection,
        routeAction?: RouteAction,
        routerOptions?: RouterOptions,
        animationBuilder?: AnimationBuilder
    ) => {
        // If there is no routerOptions or no routerOptions.unmount, set it to true
        if (!routerOptions || routerOptions.unmount === undefined) {
            routerOptions = { ...routerOptions, unmount: true };
        }
        router.push(
            pathname,
            routerDirection,
            routeAction,
            routerOptions,
            animationBuilder
        );
    };

    return {
        ...router,
        push,
    } as UseIonRouterResult;
};
